import React, { useState, useEffect, useContext } from 'react';
import ServiceRasci from '../../../services-admin/rasci';
import ServiceGeneral from '../../../services/general';
import { TextField } from '../../ui/textField';
import readXlsxFile from 'read-excel-file'
import { Tabs } from '../../ui/tabs';
import { csv2json, json2csv } from 'json-2-csv';
import { ContextUI } from '../../../uiContext';
import { LinearProgress } from '../../ui/linearProgress';
const EditGeneral = ({ rasciID, item, onChange }) => {
  const contextUI = useContext(ContextUI);
  const [file, setFile] = useState(); //attribute for importing excel
  const [selectedTab, setSelectedTab] = useState(0);
  const [importOrganisations, setImportOrganisations] = useState([]);
  const [importOpleidingen, setImportOpleidingen] = useState([]);
  const [importMurity, setImportMarturity] = useState([]);
  const [importOverleggen, setImportOverleggen] = useState([]);
  const [importWerkDocumenten, setImportWerkDocumenten] = useState([]);
  const [importTaken, setImportTaken] = useState([]);
  const [importVerantwoordelijkheden, setImportVerantwoordelijkheden] = useState([]);
  const [importFunctions, setImportFuncties] = useState([])
  const [isImporting, setIsImporting] = useState(false);
  const [percentageProgress, setPercentageProgress] = useState(100);
  //function for importing excel
  useEffect(() => {
    //    const input = document.getElementById('inputexcelfilecontacts');
    //    input.addEventListener('change', importExcel)
    //    return () => {
    //    input.removeEventListener('change', importExcel);
    ///    }
  }, [])

  //  const importExcel = (ev) => {
  //   if (ev.target && ev.target.files && ev.target.files.length > 0 && ev.target.files[0].name.toLowerCase().indexOf('.xlsx') > 0) {
  //      setFile(ev.target.files[0])
  //     ev.target.value = '';
  //   }
  // }

  useEffect(() => {
    if (file) {
      //{ sheet: selectedTab }
      readXlsxFile(file, { sheet: 'FDB_MaturityModel' }).then((rows) => {
        console.log('Maturity', rows);
        setImportMarturity(rows);
      }).catch((err) => {
        console.log(err)
      })
      readXlsxFile(file, { sheet: 'FDB_Opleidingen' }).then((rows) => {
        console.log('Opleidingen', rows);
        setImportOpleidingen(rows);
      }).catch((err) => {
        console.log(err)
      })
      readXlsxFile(file, { sheet: 'FDB_Organisaties' }).then((rows) => {
        console.log('Organisations', rows);
        setImportOrganisations(rows);
      }).catch((err) => {
        console.log(err)
      })
      readXlsxFile(file, { sheet: 'FDB_Overleggen' }).then((rows) => {
        console.log('Overleggen', rows);
        setImportOverleggen(rows);
      }).catch((err) => {
        console.log(err)
      })
      readXlsxFile(file, { sheet: 'FDB_werkdocumenten' }).then((rows) => {
        console.log('Werkdocumenen', rows);
        setImportWerkDocumenten(rows);
      }).catch((err) => {
        console.log(err)
      })
      readXlsxFile(file, { sheet: 'FDB_Taken' }).then((rows) => {
        console.log('Taken', rows);
        setImportTaken(rows);
      }).catch((err) => {
        console.log(err)
      })
      readXlsxFile(file, { sheet: 'FDB_Verantwoordelijkheden' }).then((rows) => {
        console.log('Verantwoordelijkheden', rows);
        setImportVerantwoordelijkheden(rows);
      }).catch((err) => {
        console.log(err)
      })
      readXlsxFile(file, { sheet: 'FDB_Functies' }).then((rows) => {
        console.log('Functies', rows);
        setImportFuncties(rows);
      }).catch((err) => {
        console.log(err)
      })
    }
  }, [file])

  //end function for importing excel

  //  <TextField id="reference" value={iconProcess} label="Verwijzing" onChange={(ev) => handleChange('reference', ev.target.value)} onBlur={() => handleSave(editItem)} />
  function convertFileToBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      // Typescript users: use following line
      // reader.onload = () => resolve(reader.result as string);
      reader.onerror = reject;
    });
  }

  function convertFileToText(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsText(file);
      reader.onload = () => resolve(reader.result);
      // Typescript users: use following line
      // reader.onload = () => resolve(reader.result as string);
      reader.onerror = reject;
    });
  }

  const downloadCSV = async (attribute) => {

    let organisations = await ServiceRasci.get(rasciID, 'organisations');
    let educations = await ServiceRasci.get(rasciID, 'educations');
    let meetings = await ServiceRasci.get(rasciID, 'meetings');
    let functions = await ServiceRasci.get(rasciID, 'functions');
    let tasks = await ServiceRasci.get(rasciID, 'tasks');
    let processes = await ServiceRasci.get(rasciID, 'processes');
    let linkedActivities = await ServiceRasci.get(rasciID, 'linkedActivities');

    const getEducationNumber = (educationID) => { return educations.find(i => { return i._id == educationID })?.number || ""; }
    const getMeetingNumber = (meetingID) => { return meetings.find(i => { return i._id == meetingID })?.number || ""; }
    const getOrganisationNumber = (organisationID) => { return organisations.find(i => { return i._id == organisationID })?.number || ""; }
    const getFunctionNumber = (functionID) => { return functions.find(i => { return i._id == functionID })?.number || ""; }
    const getTaskNumber = (taskID) => { return tasks.find(i => { return i._id == taskID })?.number || ""; }
    const getProcessNumber = (processID) => { return processes.find(i => { return i._id == processID })?.number || ""; }

    let string = "";
    let returnItems = [];
    switch (attribute) {
      case 'organisations':
        returnItems = organisations.map((item) => { return { number: ""+item.number, name: item.name || "", note: item.note || "", short: item.short || "" } });
        string = json2csv(returnItems);
        break;
      case 'educations':
        returnItems = educations.map((item) => { return { number: ""+item.number, name: item.name || "", note: item.note || "" } });
        string = json2csv(returnItems);
        break;
      case 'meetings':
        returnItems = meetings.map((item) => { return { number: ""+item.number, name: item.name || "", note: item.note || "" } });
        string = json2csv(returnItems);
        break;
      case 'tasks':
        returnItems = tasks.map((item) => { return { number:""+ item.number, name: item.name || "", reference: item.reference || "" } });
        string = json2csv(returnItems);
        break;
      case 'functions':
        returnItems = functions.map((item) => { return { number:""+ item.number, name: item.name || "", frame: item.frame || "", targets: item.targets || "", profile: item.profile || "", contacts: item.contacts || "", organisation: getOrganisationNumber(item.organisation), educations: item.educations.map(edu => { return getEducationNumber(edu) }).join(";"), meetings: item.meetings.map(meet => { return getMeetingNumber(meet) }).join(";") } });
        string = json2csv(returnItems);
        break;
      case 'processes':
        returnItems = processes.map((item) => { return { number: ""+item.number, name: item.name || "", short: item.short || "", level: item.level || 0, parent: getProcessNumber(item.parent) || "", note: item.note || "", pdca: item.pdca || "", link: item.link || "", defaultSelected: (item.defaultSelected ? true : false), linkedFunctionsTasksRasci: linkedActivities.filter(la => { return la.processID == item._id }).map(la => { return getFunctionNumber(la.functionID) + ":" + getTaskNumber(la.taskID) + ":" + la.rasci }).join("; ") } });
        string = json2csv(returnItems);
        break;
    }

    const blob = new Blob([string], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = attribute + '.csv';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);

  }

  const uploadCSV = async (attribute, event) => {
    contextUI.setMessage("Importeren gestart, een moment geduld aub...");
    const uploadedCSV = await convertFileToText(event.target.files[0]);
    event.target.value = '';
    let newItems = csv2json(uploadedCSV);
    await clearDatabase(rasciID, attribute);
    setPercentageProgress(10);
    let organisations = await ServiceRasci.get(rasciID, 'organisations');
    let educations = await ServiceRasci.get(rasciID, 'educations');
    let meetings = await ServiceRasci.get(rasciID, 'meetings');
    let functions = await ServiceRasci.get(rasciID, 'functions');
    let tasks = await ServiceRasci.get(rasciID, 'tasks');

    switch (attribute) {
      case 'organisations':
        for (let i = 0; i < newItems.length; i++) {
          let newItem = {}
          newItem.rasciID = rasciID;
          newItem.name = newItems[i].name;
          newItem.note = newItems[i].note;
          newItem.number = newItems[i].number;
          newItem.short = newItems[i].short;
          newItem.active = true;
          await ServiceRasci.update(rasciID, 'organisations', newItem)
        }
        break;
      case 'educations':
        for (let i = 0; i < newItems.length; i++) {
          let newItem = {}
          newItem.rasciID = rasciID;
          newItem.name = newItems[i].name;
          newItem.number = newItems[i].number;
          newItem.note = newItems[i].note;
          newItem.active = true;
          await ServiceRasci.update(rasciID, 'educations', newItem)
        }
        break;
      case 'meetings':
        for (let i = 0; i < newItems.length; i++) {
          let newItem = {}
          newItem.rasciID = rasciID;
          newItem.name = newItems[i].name;
          newItem.number = newItems[i].number;
          newItem.note = newItems[i].note;
          newItem.active = true;
          await ServiceRasci.update(rasciID, 'meetings', newItem)
        }
        break;
      case 'tasks':
        for (let i = 0; i < newItems.length; i++) {
          let newItem = {}
          newItem.rasciID = rasciID;
          newItem.name = newItems[i].name;
          newItem.number = newItems[i].number;
          newItem.reference = newItems[i].reference;
          newItem.active = true;
          await ServiceRasci.update(rasciID, 'tasks', newItem)
        }
        break;
      case 'functions':
        for (let i = 0; i < newItems.length; i++) {
          let newItem = {}
          newItem.rasciID = rasciID
          newItem.number = newItems[i].number;
          newItem.name = newItems[i].name;
          console.log('Searching for organisation', newItems[i].organisation, organisations);
          let foundOrg = organisations.find(c => { return c.number == newItems[i].organisation })
          if (foundOrg) {
            console.log('Found organisation', foundOrg);
            newItem.organisation = foundOrg._id;
          }
          newItem.targets = newItems[i].targets;
          newItem.contacts = newItems[i].contacts;
          newItem.frame = newItems[i].frame;
          newItem.profile = newItems[i].profile;

          newItem.educations = [];
          if (newItems[i].educations) {
            let educationNumbers = (newItems[i].educations + "").split(';');
            for (let j = 0; j < educationNumbers.length; j++) {
              let foundEducation = educations.find(c => { return c.number == educationNumbers[j] })
              if (foundEducation) {
                newItem.educations.push(foundEducation._id);
              }
            }
          }

          newItem.meetings = [];
          let meetingNumbers = (newItems[i].meetings + "").split(';');
          for (let j = 0; j < meetingNumbers.length; j++) {
            let foundMeeting = meetings.find(c => { return c.number == meetingNumbers[j] })
            if (foundMeeting) {
              newItem.meetings.push(foundMeeting._id);
            }
          }
          newItem.active = true
          await ServiceRasci.update(rasciID, 'functions', newItem)
        }
        break;
      case 'processes':
        //clear database    
        await clearDatabase(rasciID, 'linkedActivities');
        setPercentageProgress(20);
        //hoofdstuk
        let chapters = newItems.filter(i => { return i.level == 0 });
        for (let i = 0; i < chapters.length; i++) {
          let newItem = {}
          newItem.rasciID = rasciID;
          newItem.name = chapters[i].name;
          newItem.number = chapters[i].number;
          newItem.short = chapters[i].short;
          newItem.level = chapters[i].level;
          newItem.active = true;
          await ServiceRasci.update(rasciID, 'processes', newItem)
        }
        chapters = await ServiceRasci.get(rasciID, 'processes');
        setPercentageProgress(40);
        //paragraaf
        let paragraphs = newItems.filter(i => { return i.level == 1 });
        for (let i = 0; i < paragraphs.length; i++) {
          let newItem = {}
          newItem.rasciID = rasciID;
          newItem.name = paragraphs[i].name;
          newItem.number = paragraphs[i].number;
          newItem.level = paragraphs[i].level;
          let foundParent = chapters.find(c => { return c.number == paragraphs[i].parent });
          if (foundParent) {
            newItem.parent = foundParent._id;
          }
          newItem.active = true;
          await ServiceRasci.update(rasciID, 'processes', newItem)
        }
        paragraphs = await ServiceRasci.get(rasciID, 'processes');
        setPercentageProgress(60);
        //product
        let products = newItems.filter(i => { return i.level == 2 });
        for (let i = 0; i < products.length; i++) {
          setPercentageProgress(70 + (i * 10) / products.length);
          let newItem = {}
          newItem.rasciID = rasciID;
          newItem.name = products[i].name;
          newItem.number = products[i].number;
          newItem.short = products[i].short;
          newItem.note = products[i].note;
          newItem.pdca = products[i].pdca;
          newItem.link = products[i].link;
          newItem.defaultSelected = products[i].defaultSelected;
          newItem.level = products[i].level;
          let foundParent = paragraphs.find(c => { return c.number == products[i].parent });
          if (foundParent) {
            newItem.parent = foundParent._id;
          }
          newItem.active = true;
          let updateResult = await ServiceRasci.update(rasciID, 'processes', newItem);
          //linkedActivities
          if (updateResult[0] && products[i].linkedFunctionsTasksRasci) {
            let _id = updateResult[0]._id;
            let linkedFunctionsTasksRasci = products[i].linkedFunctionsTasksRasci.split(';');
            if (linkedFunctionsTasksRasci.length > 0) {
              for (let j = 0; j < linkedFunctionsTasksRasci.length; j++) {
                let attributeIDs = linkedFunctionsTasksRasci[j].split(':');
                let newItem = {}
                newItem.rasciID = rasciID;
                let foundFunct = functions.find(f => { return (""+f.number).trim() == (""+attributeIDs[0]).trim() });
                let foundTask = tasks.find(f => { return (""+f.number).trim() == (""+attributeIDs[1]).trim() });
                let foundRASCI = attributeIDs[2];
             
                if (foundTask && foundFunct && foundRASCI && _id) {
                  newItem.functionID = foundFunct._id;
                  newItem.processID = _id;
                  newItem.taskID = foundTask._id;
                  newItem.rasci = foundRASCI;
                  newItem.active = true;
                  await ServiceRasci.update(rasciID, 'linkedActivities', newItem);
                }
              }
            }

          }
        }
        //   products = await ServiceRasci.get(rasciID, 'processes');

        //linkedActivities
        /*
        let linkedProducts = newItems.filter(i => { return i.level == 2 });
        for (let i = 0; i < linkedProducts.length; i++) {
          if (linkedProducts[i].linkedFunctionsTasksRasc) {
            let linkedFunctionsTasksRasci = linkedProducts[i].linkedFunctionsTasksRasci.split(';');
            console.log('Linked functions tasks', linkedFunctionsTasksRasci);

          }
        }
*/
        //linkedFunctionsTasksRasci

        break;
    }
    setPercentageProgress(100);
    contextUI.setMessage("Import gereed");
  }

  const uploadImageToServer = async (attribute, event) => {
    try {
      const uploadedImageBase64 = await convertFileToBase64(event.target.files[0]);

      let tmpItem = Object.assign({}, item);
      tmpItem[attribute] = uploadedImageBase64;
      onChange(tmpItem);
    } catch (ex) {
      console.log(ex);
    }

  }
  /* IMPORT */

  const clearDatabase = async (rasciID, table) => {
    return new Promise((resolve, reject) => {
      ServiceRasci.get(rasciID, table).then(async result => {
        //delete current chapters
        for (let i = 0; i < result.length; i++) {
          await ServiceRasci.update(rasciID, table, { _id: result[i]._id, active: false })
        }
        resolve();
      })
    })
  };

  //nieuwe import
  const handleImportExcel = async () => {
    setIsImporting(true);
    const clearDatabase = async (rasciID, table) => {
      return new Promise((resolve, reject) => {
        ServiceRasci.get(rasciID, table).then(async result => {
          //delete current chapters
          for (let i = 0; i < result.length; i++) {
            await ServiceRasci.update(rasciID, table, { _id: result[i]._id, active: false })
          }
          resolve();
        })
      })
    };

    //chapters

    await clearDatabase(rasciID, 'processes');
    await clearDatabase(rasciID, 'organisations');
    await clearDatabase(rasciID, 'meetings');
    await clearDatabase(rasciID, 'educations');
    await clearDatabase(rasciID, 'functions');
    await clearDatabase(rasciID, 'tasks');
    await clearDatabase(rasciID, 'linkedActivities');
    console.log('Database opgeschoond');

    //add organisations
    for (let i = 1; i < importOrganisations.length; i++) {
      let newItem = {}
      newItem.rasciID = rasciID;
      newItem.id = importOrganisations[i][0];
      newItem.name = importOrganisations[i][2];
      newItem.note = importOrganisations[i][3];
      newItem.number = importOrganisations[i][1];
      newItem.short = importOrganisations[i][4];
      newItem.active = true;
      await ServiceRasci.update(rasciID, 'organisations', newItem)
    }
    let organisations = await ServiceRasci.get(rasciID, 'organisations');
    console.log('Organisaties toegevoegd');

    //add opleidingen
    for (let i = 1; i < importOpleidingen.length; i++) {
      let newItem = {}
      newItem.rasciID = rasciID;
      newItem.id = importOpleidingen[i][0];
      newItem.name = importOpleidingen[i][3];
      newItem.number = importOpleidingen[i][0];
      newItem.active = true;
      await ServiceRasci.update(rasciID, 'educations', newItem)
    }
    let educations = await ServiceRasci.get(rasciID, 'educations');
    console.log('Opleidingen toegevoegd');

    //add overleggen
    for (let i = 2; i < importOverleggen.length; i++) {
      let newItem = {}
      newItem.rasciID = rasciID;
      newItem.id = importOverleggen[i][0];
      newItem.number = importOverleggen[i][0];
      newItem.name = importOverleggen[i][1];
      newItem.active = true;
      await ServiceRasci.update(rasciID, 'meetings', newItem)
    }
    let meetings = await ServiceRasci.get(rasciID, 'meetings');
    console.log('Overleggen toegevoegd');

    //add tasks
    for (let i = 2; i < importTaken.length; i++) {
      let newItem = {}
      newItem.rasciID = rasciID;
      newItem.id = importTaken[i][0];
      newItem.number = importTaken[i][1];
      newItem.name = importTaken[i][2];
      newItem.active = true;
      await ServiceRasci.update(rasciID, 'tasks', newItem)
    }
    let tasks = await ServiceRasci.get(rasciID, 'tasks');
    console.log('Taken toegevoegd');


    //add functions
    for (let i = 1; i < importFunctions.length; i++) {
      console.log('Import functie ', importFunctions[i])
      let newItem = {}
      newItem.rasciID = rasciID
      newItem.id = importFunctions[i][0];
      newItem.number = importFunctions[i][1];
      newItem.name = importFunctions[i][2].replace(newItem.number + '. ', '');
      let foundOrg = organisations.find(c => { return c.name == importFunctions[i][6] })
      if (foundOrg) {
        newItem.organisation = foundOrg._id;
      }
      newItem.targets = importFunctions[i][3];
      //  newItem.contacts = importFunctions[i][0];
      newItem.frame = importFunctions[i][4];
      //   newItem.profile = importFunctions[i][0]; 
      newItem.educations = [];
      if (importFunctions[i][5]) {
        let educationNames = importFunctions[i][5].split(';');
        for (let j = 0; j < educationNames.length; j++) {
          let foundEducation = educations.find(c => { return c.name.trim() == educationNames[j].trim() })
          if (foundEducation) {
            newItem.educations.push(foundEducation._id);
          }
        }
      }
      newItem.meetings = [];
      for (let i = 2; i < importOverleggen.length; i++) {
        if (importOverleggen[i][3]) {
          let foundMeetingImport = importOverleggen[i][3].indexOf(newItem.name) >= 0;
          if (foundMeetingImport) {
            let foundMeeting = meetings.find(m => { return m.id == importOverleggen[i][0] });
            if (foundMeeting) {
              newItem.meetings.push(foundMeeting._id);
            }
          }
        }

      }
      newItem.active = true
      await ServiceRasci.update(rasciID, 'functions', newItem)
    }
    let functions = await ServiceRasci.get(rasciID, 'functions');
    console.log('Functies toegevoegd');


    //add Chapter
    for (let i = 1; i < importMurity.length; i++) {
      if (!importMurity[i][1]) {
        let newItem = {}
        newItem.rasciID = rasciID;
        newItem.id = importMurity[i][0];
        newItem.number = importMurity[i][2];
        newItem.name = importMurity[i][3];
        newItem.short = '';
        newItem.level = 0;
        newItem.active = true;
        await ServiceRasci.update(rasciID, 'processes', newItem)
      }
    }
    let chapters = await ServiceRasci.get(rasciID, 'processes');
    console.log('Hoofdstukken toegevoegd');

    //add paragraphs
    for (let i = 1; i < importMurity.length; i++) {
      if (importMurity[i][1]) {
        let newItem = {}
        newItem.rasciID = rasciID;
        newItem.id = importMurity[i][0];
        let foundParent = chapters.find(c => { return c.number + ' ' + c.name == importMurity[i][1] });
        if (foundParent) {
          newItem.parent = foundParent._id;
          newItem.name = importMurity[i][3];
          newItem.number = importMurity[i][2];
          newItem.level = 1;
          newItem.active = true;
          await ServiceRasci.update(rasciID, 'processes', newItem)
        }
      }
    }
    let paragraphs = await ServiceRasci.get(rasciID, 'processes');
    console.log('Paragrafen toegevoegd');

    //add products
    for (let i = 1; i < importWerkDocumenten.length; i++) {
      let newItem = {}
      newItem.rasciID = rasciID;
      newItem.id = importWerkDocumenten[i][0];
      let foundParent = paragraphs.find(c => { return c.number + ' ' + c.name == importWerkDocumenten[i][7] });
      if (foundParent) {
        newItem.parent = foundParent._id;
        newItem.name = importWerkDocumenten[i][2];
        newItem.number = importWerkDocumenten[i][1];
        newItem.note = importWerkDocumenten[i][3];
        newItem.pdca = importWerkDocumenten[i][4];
        newItem.level = 2;
        newItem.active = true;
        await ServiceRasci.update(rasciID, 'processes', newItem)
      }
    }
    let products = await ServiceRasci.get(rasciID, 'processes');
    console.log('Producten toegevoegd');

    //add linkedActivities
    for (let i = 2; i < importVerantwoordelijkheden.length; i++) {
      let newItem = {}
      newItem.rasciID = rasciID;
      let foundFunct = functions.find(f => { return f.number + '. ' + f.name == importVerantwoordelijkheden[i][2] });
      let foundTask = tasks.find(f => { return f.number == importVerantwoordelijkheden[i][1] });
      let searchImportTask = importTaken.find(f => { return f[1] == importVerantwoordelijkheden[i][1] });
      let foundProcess;
      if (searchImportTask) {
        foundProcess = products.find(p => { return p.number + ' ' + p.name == searchImportTask[3] });
      }
      // console.log(foundTask , foundFunct , foundProcess)
      if (foundTask && foundFunct && foundProcess) {
        newItem.functionID = foundFunct._id;
        newItem.processID = foundProcess._id;
        newItem.taskID = foundTask._id;
        newItem.rasci = importVerantwoordelijkheden[i][3];
        newItem.active = true;
        await ServiceRasci.update(rasciID, 'linkedActivities', newItem);
      }
    }
    console.log('LinkedActivities toegevoegd');
    alert('Import gereed');
    setIsImporting(false);
  }

  /* EINDE IMPORT */
  if (!item) return null;
  /*
     <div className='label'>Icoon Taken</div>
      {item.iconTasks && <img src={item.iconTasks} style={{ width: '150px', height: 'auto' }} />}
      <input type="file" onChange={(e) => { uploadImageToServer('iconTasks', e) }} />
      */
  //<div  onClick={handleImport}>.</div>
  const buttonStyle = {
    textDecoration: 'underline',
    cursor: 'pointer'
  };
  return (
    <div className='padding'>


      <Tabs value={selectedTab} onChange={setSelectedTab} >
        <div>CSV IMPORT/EXPORT</div>
        <div>AFBEELDINGEN</div>
      </Tabs>
      {percentageProgress < 100 && <LinearProgress value={percentageProgress} />}
      {selectedTab == 0 && <div>
        <br />
        <table cellPadding={14} cellSpacing={14}>
          <thead>
            <tr>
              <th></th>
              <th  >Dataset</th>
              <th  >Download</th>
              <th  >Upload</th>
              <th> Notitie</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td valign='top'>1.</td>
              <td valign='top'>Organisaties</td>
              <td valign='top'><div style={buttonStyle} variant="text" onClick={() => { downloadCSV("organisations") }}>download</div></td>
              <td valign='top'><input type="file" onChange={(e) => { uploadCSV("organisations", e) }} /></td>
              <td valign='top'>Na uploaden organisatie de <b>functies</b> opnieuw inladen</td>
            </tr>
            <tr>
              <td valign='top'>2.</td>
              <td valign='top'>Opleidingen</td>
              <td valign='top'><div style={buttonStyle} variant="text" onClick={() => { downloadCSV("educations") }}>download</div></td>
              <td valign='top'><input type="file" onChange={(e) => { uploadCSV("educations", e) }} /></td>
              <td valign='top'>Na uploaden opleidingen de <b>functies</b> opnieuw inladen</td>
            </tr>
            <tr>
              <td valign='top'>3.</td>
              <td valign='top'>Overleggen</td>
              <td valign='top'><div style={buttonStyle} variant="text" onClick={() => { downloadCSV("meetings") }}>download</div></td>
              <td valign='top'><input type="file" onChange={(e) => { uploadCSV("meetings", e) }} /></td>
              <td valign='top'>Na uploaden overleggen de <b>functies</b> opnieuw inladen</td>
            </tr>
            <tr>
              <td valign='top'>4.</td>
              <td valign='top'>Functies</td>
              <td valign='top'><div style={buttonStyle} variant="text" onClick={() => { downloadCSV("functions") }}>download</div></td>
              <td valign='top'><input type="file" onChange={(e) => { uploadCSV("functions", e) }} /></td>
              <td valign='top'>Na uploaden functies de <b>processen</b> opnieuw inladen<br/>
              Educations: Nummers van de opleidingen gescheiden door ;<br/>
              Meetings: Nummers van de overleggen gescheiden door ;<br/>
              </td>
            </tr>
            <tr>
              <td valign='top'>5.</td>
              <td valign='top'>Taken</td>
              <td valign='top'><div style={buttonStyle} variant="text" onClick={() => { downloadCSV("tasks") }}>download</div></td>
              <td valign='top'><input type="file" onChange={(e) => { uploadCSV("tasks", e) }} /></td>
              <td valign='top'>Na uploaden taken de <b>processen</b> opnieuw inladen</td>
            </tr>
            <tr>
              <td valign='top'>6.</td>
              <td  valign='top'>Processen</td>
              <td  valign='top'><div style={buttonStyle} variant="text" onClick={() => { downloadCSV("processes") }}>download</div></td>
              <td  valign='top'><input type="file" onChange={(e) => { uploadCSV("processes", e) }} /></td>
              <td>Level 0 : Hoofdstuk<br/>Level 1: Paragraaf<br/>Level 2: Product<br/><br/>Parent: number veld van hoofdstuk of paragraaf
              <br/><br/>
              PDCA : P (Plan), D (Do), C (Check), A (Act), K (Kader)<br/><br/>
              LinkedFunctionsTasksRasci : Nummer functie : Nummer taak : Letter RASCI<br/> (Meerder gescheiden door ; )<br/><br/>
              </td>
            </tr>

          </tbody>
        </table>

        <br />
      </div>}
      {selectedTab == 1 && <div>
        <br />
        <div className='label'>Icoon werkprocessen/producten</div>
        {item.iconWorkProcess && <img src={item.iconWorkProcess} style={{ width: '150px', height: 'auto' }} />}
        <input type="file" onChange={(e) => { uploadImageToServer('iconWorkProcess', e) }} />

        <div className='label'>Icoon rollen/taakomschrijving</div>
        {item.iconWorkRoles && <img src={item.iconWorkRoles} style={{ width: '150px', height: 'auto' }} />}
        <input type="file" onChange={(e) => { uploadImageToServer('iconWorkRoles', e) }} />

        <div className='label'>Icoon RASCI tabel</div>
        {item.iconWorkTable && <img src={item.iconWorkTable} style={{ width: '150px', height: 'auto' }} />}
        <input type="file" onChange={(e) => { uploadImageToServer('iconWorkTable', e) }} />

      </div>
      }



      <br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />

    </div>
  );
};

export default EditGeneral;